<template>
  <Modal
    :cancelFunction="closeModal"
    :okFunction="deleteApperanceScheme"
    title="Delete Confirmation"
  >
    <template v-slot:body> Are you sure you want to delete this scheme? </template>
  </Modal>
</template>

<script>
  import Modal from '@/components/common/Modal.vue';
  import { apiDeleteOrganisationScheme, apiDeleteUserOrganisationScheme } from '@/api/organisation';

  export default {
    name: 'DeleteSchemeModal',
    components: { Modal },
    props: {
      scheme: {
        type: Object,
        required: true,
      },
    },
    mounted() {
      this.showModal = true;
    },
    methods: {
      async deleteApperanceScheme() {
        try {
          if (this.isAdmin) {
            await apiDeleteOrganisationScheme(this.scheme.id);
          } else {
            await apiDeleteUserOrganisationScheme(this.scheme.id);
          }
          this.$emit('deleted', this.scheme.id);
          this.closeModal();
          this.$toasted.global.general_success({
            message: 'Scheme deleted successfully',
          });
        } catch (error) {
          this.$toasted.global.general_error({
            message:
              error?.response?.data?.message ?? error?.data?.message ?? 'Error deleting scheme',
          });
        }
      },
      closeModal() {
        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" scoped></style>
